export const FLAT_FORM_ADDITIONAL_FIELDS_COUNT = 4
